<template>
    <span :class="classes"><slot></slot></span>
</template>

<script>
    export default {
        props: ['classes']
    }
</script>

<style scoped>

</style>
